export const StyleModifiers = ['container-style', 'secondary', 'destructive', 'destructive-secondary', 'tertiary'];
